var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdea = function SvgIdea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.501 11h-5v1h5zM6.501 13h-3v1h3zM5.001 0a5 5 0 0 0-5 5 4.6 4.6 0 0 0 1.73 3.81c.5.465.77.73.77 1.19h1c0-.92-.555-1.435-1.095-1.93A3.6 3.6 0 0 1 1.001 5a4 4 0 0 1 8 0 3.6 3.6 0 0 1-1.41 3.07c-.535.5-1.09 1-1.09 1.93h1c0-.46.265-.725.77-1.195A4.59 4.59 0 0 0 10.001 5a5 5 0 0 0-5-5"
  })));
};
export default SvgIdea;